import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { motion } from 'framer-motion'
import { colors } from 'theme/colors'
import CloseButton from 'common/components/CloseButton'

export const TraceNotFound = ({ close }) => {
  let errorMessage = "We're not able to load details for this Trace"

  return (
    <Box
      component={motion.div}
      sx={{ minHeight: 'var(--app-height)', overflowY: 'auto' }}
      bgcolor="background.default"
    >
      <Box>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
          <CloseButton
            onClick={close}
            aria-label="close details"
            size="medium"
            style={{ marginLeft: 'auto' }}
          />
        </Box>
        <Box
          height="100%"
          minHeight={300}
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <NotFoundTitle variant="h2">Trace not found</NotFoundTitle>
          <Typography variant="textPrimary" color="text.secondary">
            {errorMessage}
          </Typography>
          <NotFoundLink variant="textPrimary" onClick={close}>
            Back to explorer
          </NotFoundLink>
        </Box>
      </Box>
    </Box>
  )
}

const NotFoundTitle = styled(Typography)({
  color: colors.redPrimary,

  margin: 0,
})

const NotFoundLink = styled(Typography)({
  cursor: 'pointer',
  opacity: 0.55,
  textDecoration: 'underline',
  margin: 0,
})
